import React from 'react'
import nl2br from 'react-nl2br'
import Linkify from 'react-linkify'
import { LoadMore } from 'react-weui'
import { TimeStream, filterHTML, replaceNewHost, getAccessToken } from '../utils'
import '../css/page/MessageChatPage.css'
import { Page } from '../components'


class MessageInfoPage extends React.Component {
    constructor (props) {
        super(props)
        this.receiverId = +atob(props.params.receiverId)
        this.state = {
            msgs: null,
            nickname: '',
        }
    }
    componentDidMount () {
        document.title = '新的消息'
        this.fetchLiveroomMsgs()
    }
    fetchLiveroomMsgs () {
        const token = getAccessToken()
        const receiverId = this.receiverId
        return window.axiosMsg.get(`/msg/${receiverId}/list`, {
            params: {
                token
            }
        }).then(res => {
            if (res.data.code === 0) {
                const message_list = res.data.data.message_list
                if (message_list.length > 0) {
                    this.setState({msgs: message_list, nickname: message_list[0].nickname})
                } else {
                    this.setState({msgs: message_list})
                }
            }
        })
    }
    renderTimeItem (time) {
        return (
            <div className="show-time text-center">
                <span>{TimeStream(time)}</span>
            </div>
        )
    }
    renderOtherItem (item) {
        let isFlag = item.content.indexOf('qlchat') === -1 && item.content.indexOf('qianliao') === -1 && item.content.indexOf('xiaoe') === -1
        return (
            <div key={item.create_time}>
                {this.renderTimeItem(item.create_time)}
                <div className="weui-flex msg-item msg-opposite">
                    <div className="weui-flex__item flex_2 text-center">
                        <div className="portrait"><img src={item.avatar} /></div>
                    </div>
                    <div className="weui-flex__item flex_10">
                        <div className="msg-cnt">
                            <div className="msg-dec msg-txt">
                                {isFlag ?
                                 <Linkify properties={{target: "_blank"}}>{nl2br(replaceNewHost(item.content))}</Linkify>
                                 :
                                 <pre className="text-minor text-justify" dangerouslySetInnerHTML={{__html: filterHTML(replaceNewHost(item.content))}}/>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    renderMsgs (list) {
        if (!list) return <LoadMore loading></LoadMore>
        return list.map(item => {
            return this.renderOtherItem(item)
        })
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page message-chat-page">
                    <div className="nav-bar nav-bar-fixed">
                        <p className="text-ellipsis">
                            <span className="big-font">{this.state.nickname}</span>
                        </p>
                    </div>
                    <div className="chat-list">
                        { this.renderMsgs(this.state.msgs) }
                        <div id="chat_footer"></div>
                    </div>
                </div>
            </Page>
        )
    }
}


export default MessageInfoPage



// WEBPACK FOOTER //
// ./src/pages/MessageInfoPage.js